import { ChannelStatusEnum, useChannelsListQuery } from 'entities/Channel';
import { CHANNELS_LIMIT } from 'features/Filters';
import { EPaginationParams } from 'features/Pagination';
import { OptionWithAvatar } from 'shared/ui';

interface IUseChannelOptionsParams {
	activeOnly?: boolean;
}

export const useChannelOptions = ({ activeOnly }: IUseChannelOptionsParams = {}) => {
	const { data, isFetching } = useChannelsListQuery({ [EPaginationParams.LIMIT]: CHANNELS_LIMIT });

	return {
		channelOptions:
			data?.results
				.filter((channel) => (activeOnly ? channel.status == ChannelStatusEnum.Active : true))
				.map((channel) => ({
					search: channel.name,
					label: <OptionWithAvatar name={channel.name} logo={channel.logo_url} subText={channel.subscribers_count} />,
					value: channel.uuid,
				})) || [],
		isFetching,
	};
};
